export default {
  setTableCache({ commit }, { tableKey, cacheKey, payload }) {
    commit('SET_TABLE_CACHE', { tableKey, cacheKey, payload })
  },
  markTableCacheStale({ commit }, tableKey) {
    commit('MARK_TABLE_CACHE_STALE', { tableKey })
  },
  clearTableCache({ commit }, tableKey) {
    commit('CLEAR_TABLE_CACHE', tableKey)
  },
}
